import { Stack } from '@mui/material'
import { useFormContext, useWatch } from 'react-hook-form'

import { ControlledDatePicker, ControlledSelector } from 'components/common/controller-wrapper'
import {
  BID_SPREAD_ANALYSIS_EARLIEST_DATE,
  BID_SPREAD_ANALYSIS_TIME_PERIODS,
} from 'components/reports/Metrics/constants/BidSpreadAnalysis'

import { VEHICLE_TYPES } from '../constants/vehicleTypes'
import { BidSpreadAnalysisFilterValues } from './BidSpreadAnalysisFilterCriteria'
import { BidSpreadAnalysisServiceCodeMultipleAutocomplete } from './BidSpreadAnalysisServiceCodeMultipleAutocomplete'

export const BidSpreadAnalysisFiltersForm = () => {
  const { control } = useFormContext<BidSpreadAnalysisFilterValues>()
  const period = useWatch({ control, name: 'period' })
  const customStart = useWatch({ control, name: 'customStart' })
  const customEnd = useWatch({ control, name: 'customEnd' })
  const isCustomPeriod = period === 'custom'

  return (
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      spacing={2}
      useFlexGap
      flexWrap='wrap'
      alignItems={{ xs: 'stretch', sm: 'flex-end' }}>
      <ControlledSelector
        control={control}
        name='period'
        label='Time period'
        options={BID_SPREAD_ANALYSIS_TIME_PERIODS}
        size='small'
        fullWidth={false}
        sx={{ minWidth: 180 }}
      />

      {isCustomPeriod && (
        <>
          <ControlledDatePicker
            control={control}
            name='customStart'
            label='From'
            minDate={BID_SPREAD_ANALYSIS_EARLIEST_DATE}
            maxDate={customEnd ?? new Date()}
            size='small'
            fullWidth={false}
            sx={{ minWidth: 150 }}
          />
          <ControlledDatePicker
            control={control}
            name='customEnd'
            label='To'
            minDate={customStart ?? BID_SPREAD_ANALYSIS_EARLIEST_DATE}
            maxDate={new Date()}
            size='small'
            fullWidth={false}
            sx={{ minWidth: 150 }}
          />
        </>
      )}

      <BidSpreadAnalysisServiceCodeMultipleAutocomplete />

      <ControlledSelector
        control={control}
        name='vehicleType'
        label='Vehicle type'
        options={VEHICLE_TYPES}
        size='small'
        fullWidth={false}
        sx={{ minWidth: 180 }}
      />
    </Stack>
  )
}
